import React from 'react';
import {format} from "date-fns";

import {
    Card,
    CardContent,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";

// Copy/create-state history returned by getState v2 as `copyLogs`
// (cm/ds/toh/mc). Renders nothing when there is no history.
const StateCopyLogCard = ({logs}) => {

    if (!Array.isArray(logs) || logs.length === 0) return null

    const formatDate = (timestamp) => {
        try {
            return format(new Date(timestamp), "dd.MM.yyyy HH:mm:ss")
        } catch (e) {
            return timestamp
        }
    }

    const formatIds = (userId, vendorId) => {
        if (!userId && !vendorId) return "—"
        if (!vendorId || vendorId === userId) return userId
        return `${userId} / ${vendorId}`
    }

    return (
        <Card>
            <CardContent>
                <Typography sx={{fontSize: 16}}>
                    State copy log
                </Typography>
            </CardContent>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Employee</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Source</TableCell>
                        <TableCell>Target</TableCell>
                        <TableCell>Comment</TableCell>
                        <TableCell>Result</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logs.map((log) => (
                        <TableRow key={log.id}>
                            <TableCell>{formatDate(log.timestamp)}</TableCell>
                            <TableCell>{log.employeeEmail}</TableCell>
                            <TableCell>
                                <Chip
                                    size="small"
                                    label={log.directCopy ? "Direct copy" : "State edit"}
                                    color={log.directCopy ? "warning" : "default"}
                                />
                            </TableCell>
                            <TableCell>{formatIds(log.sourceUserId, log.sourceVendorId)}</TableCell>
                            <TableCell>{formatIds(log.targetUserId, log.targetVendorId)}</TableCell>
                            <TableCell>
                                {[log.zendeskTicketId ? `ZD #${log.zendeskTicketId}` : null, log.comment]
                                    .filter(Boolean).join(" · ")}
                            </TableCell>
                            <TableCell>
                                <Tooltip title={log.error || log.result || ""}>
                                    <Chip
                                        size="small"
                                        label={log.error ? "Error" : "Success"}
                                        color={log.error ? "error" : "success"}
                                    />
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    )
}

export default StateCopyLogCard;
